import { render, staticRenderFns } from "./permissionsDialog.vue?vue&type=template&id=75849190&scoped=true"
import script from "./permissionsDialog.vue?vue&type=script&lang=js"
export * from "./permissionsDialog.vue?vue&type=script&lang=js"
import style0 from "./permissionsDialog.vue?vue&type=style&index=0&id=75849190&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75849190",
  null
  
)

export default component.exports